import { Box } from "@mui/material";
import React, { useState } from "react";

// call page
import { Navigate } from "react-router-dom";

import MasterMenu from "./Master-menu";
import ProductMaster from "./product";
import MachineParametersSettings from "../../features/master/MachineMaster";
import AddRemarks from "../../features/master/AddRemarks";
import Vendor from "../../features/purchase/vendor/Vendor";
import AddOperator from "../../features/master/AddOperator";
import AddQCPropertyMaster from "../../features/master/AddQCPropertyMaster";
import BankMaster from "../../features/master/BankMaster";
import BankIndex from "../../features/master/bank/BankIndex";
import OverTimeMaster from "../../features/master/overtimemaster/OverTimeMaster";
import OTIndex from "../../features/master/overtimemaster/OTIndex";
import RepulpWasteTypeIndex from "../../features/master/repulpwastetypemaster/RepulpWasteTypeIndex";
import WasteLocationMasterIndex from "../../features/master/repulpwastelocationmaster/WasteLocationMasterIndex";
const Masters = () => {


    const [activePage, setActivePage] = useState('ViewMainPage');

    const SetActive = (page) => {
        setActivePage(page);
    }

    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }

    const onClose = () => {
        setActivePage('ViewMainPage');
    }
    const open = () => {

    }

    return (


        <Box position="relative">


            {activePage === "ViewMainPage" && (<MasterMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />)}


            {activePage === "ProductMaster" && (
                <ProductMaster handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}


            {activePage === "MachineMaster" && (
                <MachineParametersSettings handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {/* {activePage === "RemarksMaster" && (
                <AddRemarks onClose={onClose} handleBackWinderMachineEntry={handleBackWinderMachineEntry} open={open} />
            )} */}
            {activePage === "RemarksMaster" && (
  <AddRemarks
    onClose={onClose}
    handleBackWinderMachineEntry={handleBackWinderMachineEntry}
    open={open}
    moduleName="RemarksMaster"
    parentModuleName="Master"
    userPermissions={[]} // or actual permission data from parent
  />
)}
             {activePage === "BankMaster" && (
                <BankIndex  handleBackWinderMachineEntry={handleBackWinderMachineEntry}  />
            )}
            {activePage === "OverTimeMaster" && (
                <OTIndex  handleBackWinderMachineEntry={handleBackWinderMachineEntry}  />
            )}
            {activePage === "PartyMaster" && (
                <Vendor handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

  {activePage === "Operator" && (
                     <AddOperator onClose={onClose}  handleBackWinderMachineEntry={handleBackWinderMachineEntry} open={open} />
            )}

            
  {activePage === "QCProperty" && (
                     <AddQCPropertyMaster   handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "RepulpWasteMaster" && (
                     <RepulpWasteTypeIndex   handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

{activePage === "RepulpWasteLocationMaster" && (
                     <WasteLocationMasterIndex   handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

        </Box>
    );
};
export default Masters;